<template>
  <div>
    <ul v-if="count > 0">
      <li v-for="(timesheet, index) in timesheets" v-loading="processing(timesheet)" :key="index">
        <h4><i class="fa fa-user"></i> {{ userName(timesheet.user) }}</h4>
        <p>Week: <strong>{{ timesheet.week }}</strong> Year: <strong>{{ timesheet.year }}</strong></p>
        <p>Status: {{ timesheet.status }}</p>
        <p class="muted"><small>(Submitted at: {{ timesheet.created_at | formatTime }})</small></p>
        <div class="buttons">
          <router-link :to="{ name: 'timesheet', params: { id: timesheet.id } }"><el-button type="primary">Show</el-button></router-link>
        </div>
      </li>
    </ul>
    <div class="not-found" v-else>
      <slot name="notFound">
        <el-alert type="info" :closable="false" title="No timesheets found!" center></el-alert>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TimesheetsListByUser',
    props: {
      timesheets: {
        type: Array,
        required: false,
      },
    },
    computed: {
      count() {
        return this.timesheets ? this.timesheets.length : 0;
      },
    },
    methods: {
      processing(timesheet) {
        return this.$store.getters['entities/timesheets/isUpdating'](timesheet.id);
      },

      userName(user) {
        return (user.profile) ? `${user.email} (${user.profile.first_name} ${user.profile.last_name})` : user.email;
      },
    },
  };
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/timesheet/TimesheetsListByUser.vue